/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_eebaaf8a"]'><div><cube-modal ref="__mpx_ref_modal__" title="我是标题~" content="我是正文我是正文我是正文我是正文我是正文我是正文" confirm-btn="确认按钮" cancel-btn="取消按钮" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'/><cube-button @_click="onTap">modal-竖直两个按钮</cube-button></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_eebaaf8a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_eebaaf8a"}
  /** script content **/
  require("./modal-tow-vertical-btn.mpx.js?isComponent&outputPath=components%2Fmodal-tow-vertical-btneebaaf8a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-tow-vertical-btn.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-tow-vertical-btneebaaf8a%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_eebaaf8a"],
    ctorType: "component",
    outputPath: "components/modal-tow-vertical-btneebaaf8a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>